import React from 'react';
import { Button, Card, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useVideoContext } from '../../../../hooks/use-video';
import ReplayScene from '../replay-scene/replay-scene';
import dragIcon from './drag.svg';
import SceneItems from '../scene-items/scene-items';
import { getSceneItems } from '@monorepo/types';
import AddSceneItemButton from './add-scene-item-button';
import SceneActions from './scene-actions';
import SceneLayoutActions from './scene-layout-actions';

import './scene.scss';

const { Text } = Typography;

type SceneItemProps = {
  sceneId: string;
  sceneNumber: number;
  currentTime: number;
  isGlobal?: boolean;
};

const SceneItem = ({
  sceneId,
  sceneNumber,
  currentTime,
  isGlobal = false,
}: SceneItemProps) => {
  const { t } = useTranslation();
  const { scenesMap, video, globalScene } = useVideoContext();

  const scene = isGlobal ? globalScene : scenesMap.get(sceneId);

  if (!scene) {
    return null;
  }

  const sceneStartTime = currentTime;
  const sceneEndTime = sceneStartTime + scene.duration;

  return (
    <div className={'scene-box'} key={scene._id}>
      {sceneNumber === 1 ? <SceneLayoutActions /> : null}
      <Card
        hoverable={true}
        classNames={{ body: 'scene-card-body' }}
        className={`scene scene-number-${sceneNumber}`}
        key={scene._id}
      >
        <Flex
          className="scene-header"
          align={'center'}
          justify={'space-between'}
        >
          <Flex align={'center'} gap={0}>
            <Button
              disabled={true}
              icon={<img src={dragIcon} alt="" />}
              type={'text'}
              shape={'round'}
              className="drag-handle"
            ></Button>
            <Text
              style={{ marginRight: '15px' }}
              // underline={true}
            >
              {!isGlobal
                ? t('videoEditor.scene.sceneLabel', { number: sceneNumber })
                : t('videoEditor.scene.globalSceneLabel')}
            </Text>
          </Flex>
          <Flex style={{ flexDirection: 'row' }} align={'center'}>
            <AddSceneItemButton scene={scene} />
            <SceneActions scene={scene} />
            <ReplayScene sceneId={scene._id} />
          </Flex>
        </Flex>
        <Flex
          className={'scene-body'}
          gap={25}
          style={{ flexDirection: 'column' }}
          justify="start"
          align="start"
        >
          <SceneItems scene={scene} items={getSceneItems({ scene, video })} />

          {/*<Text>{scene.text}</Text>*/}

          <div className={'scene-time'}>
            <Text type={'secondary'} style={{ fontSize: '12px' }}>
              {(sceneEndTime - sceneStartTime).toFixed(2)}s
            </Text>
          </div>
        </Flex>
        {/*{displayDivider && <Divider style={{ marginBottom: 0 }} />}*/}
      </Card>
      {isGlobal ? null : <SceneLayoutActions scene={scene} />}
    </div>
  );
};

export default SceneItem;
